import localforage from 'localforage';
import socketIOClient from 'socket.io-client';
import Config from './config';

const socket = async (params) => {
  return socketIOClient.connect(Config.ENDPOINT, {
    query: {
      token: await localforage.getItem('token'),
      ...params,
    },
  });
};

export default socket;
